import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=036aa032&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QItemLabel,QExpansionItem,QCard,QCardSection,QIcon,QDrawer} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList,QItem,QItemSection,QItemLabel,QExpansionItem,QCard,QCardSection,QIcon,QDrawer})
